import SearchInput from "component/searchInput/SearchInput";
import React, { useEffect, useState } from "react";
import styles from "./Search.module.css";
import { useForm } from "react-hook-form";
import { searchableData } from "utils/searchableData";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

function Search() {
  const { register, watch } = useForm();
  const searchValue = watch("search");
  const [searchResult, setSearchResult] = useState([]);

  useEffect(() => {
    handleSearch(searchValue);
  }, [searchValue]);

  const handleSearch = (value) => {
    const result = searchableData.filter((item) => {
      if (item?.name?.toLowerCase().includes(value?.toLowerCase())) {
        return value;
      }
    });

    if (result.length > 0) {
      setSearchResult(result);
    } else {
      setSearchResult([]);
    }
    
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={styles.search}
    >
      <div className={styles.search_input}>
        <SearchInput
          register={register}
          name="search"
          placeholder="Search anything"
        />
      </div>
      <div className={styles.search_results}>
        {searchResult.map((result) => {
          return (
            <Link to={result.action} className={styles.search_item}>
              <Typography variant="h6">{result.name}</Typography>
              <Typography>{result.description}</Typography>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default Search;
